<template>
<section class="dl-notice">
  <h2 class="dl-notice__title">Privacy &amp; Security Notice</h2>
  <div class="dl-notice__body">
    <p>
      Secure VPN is committed to protecting user privacy. The app uses secure connections to help protect your online activity and improve browsing security. Data handling practices may vary depending on app features, usage, and applicable regulations.
    </p>
    <p>
      Before installing any APK file, make sure you download it from a trusted source and keep your app updated for the best security experience.
    </p>
  </div>
</section>
</template>

<script>
export default {
  name: 'DownloadNoticeSection',
}
</script>

<style lang="scss" scoped>
.dl-notice {
  padding: 28px 32px;
  border-radius: 24px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 241, 255, 0.98) 100%);
  box-shadow: 0 12px 32px rgba(109, 74, 255, 0.06);
  box-sizing: border-box;
}

.dl-notice__title {
  margin: 0 0 16px;
  text-align: left;
  font-size: clamp(24px, 2.8vw, 32px);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--vpn-ink, #1f2430);
  font-weight: 800;
}

.dl-notice__body {
  width: 100%;

  p {
    margin: 0 0 14px;
    width: 100%;
    max-width: 100%;
    text-align: left;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 15px;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 768px) {
  .dl-notice {
    padding: 18px 14px;
    border-radius: 16px;
  }

  .dl-notice__title {
    margin-bottom: 12px;
    font-size: clamp(20px, 5.5vw, 26px);
  }

  .dl-notice__body p {
    font-size: 14px;
    line-height: 1.65;
  }
}
</style>
